/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateXeroVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createXeroVerificationKeyMutationVariables = {
    input: CreateXeroVerificationKeyInput;
};
export type createXeroVerificationKeyMutationResponse = {
    readonly createXeroVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type createXeroVerificationKeyMutation = {
    readonly response: createXeroVerificationKeyMutationResponse;
    readonly variables: createXeroVerificationKeyMutationVariables;
};



/*
mutation createXeroVerificationKeyMutation(
  $input: CreateXeroVerificationKeyInput!
) {
  createXeroVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateXeroVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateXeroVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createXeroVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createXeroVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createXeroVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createXeroVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createXeroVerificationKeyMutation(\n  $input: CreateXeroVerificationKeyInput!\n) {\n  createXeroVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b956d39804506461eb90c404cfda02cd';
export default node;
